<template>
  <div class="logo">
    <router-link to="/">
      <img src="/img/logo.png" alt="" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Logo",
};
</script>

<style lang="scss" scoped></style>
